import { render } from "./ModalFavorites.vue?vue&type=template&id=824d8eea&scoped=true"
import script from "./ModalFavorites.vue?vue&type=script&lang=js"
export * from "./ModalFavorites.vue?vue&type=script&lang=js"

import "./ModalFavorites.vue?vue&type=style&index=0&id=824d8eea&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824d8eea"]])

export default __exports__